(function () {
  'use strict';

  var THRESHOLD = 5;
  var BOUND = 'almamThumbsDrag';
  var vertical = window.matchMedia('(min-width: 990px)');

  function canDrag(list) {
    return vertical.matches && list.scrollHeight > list.clientHeight + 1;
  }

  function connect(list) {
    var startY = 0;
    var startScroll = 0;
    var pointerId = null;
    var dragging = false;

    function refreshState() {
      list.classList.toggle('thumbnail-list--draggable', canDrag(list));
    }

    function end() {
      if (pointerId === null) return;
      if (list.hasPointerCapture(pointerId)) {
        try { list.releasePointerCapture(pointerId); } catch (e) {}
      }
      pointerId = null;
      list.style.removeProperty('scroll-behavior');
      list.classList.remove('thumbnail-list--dragging');
      if (dragging) {
        setTimeout(function () { dragging = false; }, 0);
      }
    }

    list.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !canDrag(list)) return;
      pointerId = event.pointerId;
      startY = event.clientY;
      startScroll = list.scrollTop;
      dragging = false;
    });

    list.addEventListener('pointermove', function (event) {
      if (event.pointerId !== pointerId) return;
      var delta = event.clientY - startY;

      if (!dragging) {
        if (Math.abs(delta) < THRESHOLD) return;
        dragging = true;
        try { list.setPointerCapture(pointerId); } catch (e) {}
        list.style.scrollBehavior = 'auto';
        list.classList.add('thumbnail-list--dragging');
      }

      event.preventDefault();
      list.scrollTop = startScroll - delta;
    });

    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);
    list.addEventListener('lostpointercapture', end);

    list.addEventListener('click', function (event) {
      if (!dragging) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    list.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    vertical.addEventListener('change', refreshState);
    if (window.ResizeObserver) {
      new ResizeObserver(refreshState).observe(list);
    }
    refreshState();
  }

  function init(root) {
    (root || document).querySelectorAll('.product--almam media-gallery .thumbnail-list').forEach(function (list) {
      if (list.dataset[BOUND]) return;
      list.dataset[BOUND] = '1';
      connect(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
